export interface GuaEvent {
  id: string;
  title: string;
  category: string;
  tags: string[];
  summary: string;
  date: string;
  views: string;
  videoCount: number;
  hot: number;
  duration: string;
  imageUrl: string;
  content: string[];
}

export interface Category {
  key: string;
  label: string;
  icon: string;
  desc: string;
}

export const categories: Category[] = [
  { key: "all", label: "全部事件", icon: "ri-folder-2-line", desc: "实时聚合全部热门吃瓜话题" },
  { key: "mingxing", label: "明星动态", icon: "ri-star-smile-line", desc: "顶流动态、红毯造型、机场路透" },
  { key: "yule", label: "娱乐八卦", icon: "ri-sparkling-2-line", desc: "剧组路透、热搜争议、圈内话题" },
  { key: "zongyi", label: "综艺现场", icon: "ri-tv-2-line", desc: "名场面、弹幕名场面、录制花絮" },
  { key: "wanghong", label: "网络红人", icon: "ri-flashlight-line", desc: "红人动态、带货现场、破圈事件" },
  { key: "shehui", label: "社会热点", icon: "ri-fire-line", desc: "音乐节、活动现场与全网热议" },
];

export const events: GuaEvent[] = [
  {
    id: "1001",
    title: "顶流女星机场生图刷屏，网友直呼状态绝佳",
    category: "mingxing",
    tags: ["顶流", "机场路透", "造型"],
    summary: "一组机场生图意外流出，生图直出的状态引发全网热议，话题热度持续攀升。",
    date: "2026-08-18",
    views: "186万",
    videoCount: 12,
    hot: 1,
    duration: "03:26",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20fashion%20collage%20of%20an%20elegant%20asian%20woman%20at%20an%20airport%20terminal%20in%20oversized%20beige%20coat%20and%20sunglasses%2C%20soft%20camera%20flash%20bokeh%2C%20cinematic%20golden%20light%2C%20candid%20celebrity%20street%20style%20photography%2C%20dreamy%20warm%20aesthetic&width=800&height=600&seq=gua-1001&orientation=landscape",
    content: [
      "近日，一组顶流女星的机场生图在社交平台意外流出，凭借生图直出的优越状态迅速刷屏。画面中她身穿大地色系叠穿造型，步伐松弛自然，举手投足间透露出的松弛感让不少网友直呼“状态绝佳”。",
      "这组照片并非官方精修，而是由现场路人随手拍摄，因此曝光后迅速在多个平台登上热搜。评论区讨论的焦点集中在妆容、气质与穿搭品味上，相关话题阅读量在数小时内突破千万。",
      "事件发酵后，关于“生图与精修的差距”“明星真实状态的讨论”再度成为网友热议的切入点。多位时尚博主也顺势下场解析她的穿搭细节，让话题从单纯八卦延伸到了穿搭与审美层面。",
      "目前，该事件相关视频合集已持续更新，涵盖机场直拍、时尚博主解析以及网友二创作品，成为近期热度最高的吃瓜话题之一。想要了解完整脉络，收藏本站并刷新即可查看最新视频汇总。",
    ],
  },
  {
    id: "1002",
    title: "恋综节目嘉宾互动名场面，弹幕当场炸锅",
    category: "zongyi",
    tags: ["恋综", "名场面", "弹幕"],
    summary: "新一期恋综里嘉宾之间的互动名场面被网友反复回看，弹幕区一秒破万。",
    date: "2026-08-18",
    views: "132万",
    videoCount: 9,
    hot: 2,
    duration: "04:12",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20tv%20studio%20scene%20of%20young%20couple%20sitting%20on%20couch%20in%20soft%20evening%20light%20with%20warm%20string%20lights%20and%20heart%20shaped%20decor%2C%20reality%20dating%20show%20atmosphere%2C%20cozy%20romantic%20mood%2C%20golden%20hour%20glow%2C%20candid%20moment&width=800&height=600&seq=gua-1002&orientation=landscape",
    content: [
      "新一期恋爱综艺播出后，嘉宾之间的一段互动名场面被网友反复回看。镜头下的眼神交流与细节动作让观众直呼“太上头”，弹幕区在播出瞬间一秒破万，评论区秒变大型磕糖现场。",
      "这段互动之所以引发热议，一方面是因为嘉宾之间的化学反应自然真实，另一方面则在于节目组的镜头语言与配乐烘托得当，把氛围感拉满。许多观众表示“这段已经循环了无数遍”。",
      "随着话题升温，节目中的相关片段被剪辑成多个二创视频在短视频平台广泛传播，进一步放大了事件热度。不少网友开始追更嘉宾的个人动态，节目官方账号的粉丝量也随之上涨。",
      "围绕这期内容，已有多条现场花絮与幕后采访视频陆续放出，完整呈现了名场面背后的真实过程。持续关注本站的综艺现场栏目，即可第一时间看到最新片段与完整汇总。",
    ],
  },
  {
    id: "1003",
    title: "网络红人带货翻车现场，引发全网热议",
    category: "wanghong",
    tags: ["红人", "带货", "翻车"],
    summary: "某头部红人直播带货时突发状况，现场处理方式引发网友两极讨论。",
    date: "2026-08-17",
    views: "98万",
    videoCount: 7,
    hot: 3,
    duration: "02:58",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20live%20streaming%20studio%20with%20bright%20ring%20light%20and%20product%20table%2C%20phone%20on%20tripod%2C%20energetic%20young%20influencer%20gesturing%20to%20products%2C%20messy%20but%20lively%20ecommerce%20vibe%2C%20orange%20and%20amber%20lighting%2C%20editorial%20photo&width=800&height=600&seq=gua-1003&orientation=landscape",
    content: [
      "近日，某头部网络红人在直播带货过程中突发状况，原本精心准备的流程被打乱，现场反应成为直播间的“名场面”。这一段插曲被观众录屏传播后，迅速在各大平台引发热议。",
      "面对突发情况，该红人现场处理的方式引发了网友的两极讨论：一部分人认为临场反应真实可爱、反而圈粉；另一部分人则质疑准备不够充分，影响了专业度。争论之间，话题热度持续走高。",
      "事件发酵后，相关录屏、表情包和二创内容在短视频平台大量涌现，也让“直播翻车名场面”这一标签再次走红。有博主专门做了复盘视频，从流程管理角度分析翻车原因，收获大量点赞。",
      "目前该事件已被收录进本站的网络红人栏目，相关视频覆盖直播录屏、复盘解析与网友讨论合集。想看事件完整走向，收藏本站每日刷新即可获取最新汇总。",
    ],
  },
  {
    id: "1004",
    title: "电视剧剧组路透照流出，全新造型引热议",
    category: "yule",
    tags: ["剧组", "路透", "造型"],
    summary: "新剧剧组路透照意外流出，主演的全新造型成为网友讨论的焦点。",
    date: "2026-08-17",
    views: "154万",
    videoCount: 11,
    hot: 4,
    duration: "03:44",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20film%20set%20behind%20the%20scenes%20with%20camera%20equipment%20and%20actors%20in%20hanfu%20costume%20walking%20on%20ancient%20street%2C%20golden%20warm%20sunset%20light%2C%20drama%20production%20atmosphere%2C%20editorial%20film%20photography%2C%20orange%20amber%20tones&width=800&height=600&seq=gua-1004&orientation=landscape",
    content: [
      "一组新剧剧组的拍摄路透照近日在网络上意外流出，主演的全新古装造型成为网友讨论的焦点。照片中服装质感、发型细节与场景氛围都相当出挑，引发了不少人对正片的期待。",
      "路透照曝光后，粉丝与路人迅速在评论区展开讨论，从造型还原度聊到剧情猜想，热度一路走高。多个娱乐博主也加入盘点，将其与同题材作品的造型进行对比，进一步推高话题声量。",
      "面对外界的关注，剧组官方随后发布了一组正式剧照，与路透照形成呼应，并透露了更多制作细节。这一举动让话题从“偷拍路透”转向“官宣预热”，讨论方向更加丰富。",
      "该事件相关视频已收录至娱乐八卦栏目，包含路透合集、造型解析与官方剧照对比等内容。持续刷新本站，即可第一时间看到这部剧后续的更多动态与完整汇总。",
    ],
  },
  {
    id: "1005",
    title: "音乐节现场观众齐唱经典，场面超燃",
    category: "shehui",
    tags: ["音乐节", "现场", "超燃"],
    summary: "音乐节现场上万观众齐声合唱经典曲目，画面震撼被疯狂转发。",
    date: "2026-08-16",
    views: "210万",
    videoCount: 15,
    hot: 5,
    duration: "05:30",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20outdoor%20music%20festival%20crowd%20with%20raised%20hands%20and%20phone%20flashlights%20at%20dusk%2C%20stage%20lights%20in%20orange%20and%20amber%2C%20silhouettes%20of%20people%20singing%20together%2C%20emotional%20energetic%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=600&seq=gua-1005&orientation=landscape",
    content: [
      "近日某音乐节现场，上万名观众在演出的高潮阶段齐声合唱一首经典曲目，现场画面被前排观众拍下并疯狂转发。整齐的歌声与挥舞的手机灯光交相辉映，场面十分震撼。",
      "这段现场视频发布后迅速破圈，不少网友表示“隔着屏幕都被感染到”。有人留言说听出了青春的味道，也有人开始考古这首歌的原唱与历年现场版本，话题热度持续攀升。",
      "随后，更多现场视角的视频陆续流出，从正面主舞台到侧边看台，多机位还原了那一刻的万人合唱。这些素材被剪辑成合集，成为近期社会热点栏目下传播最广的视频之一。",
      "音乐节与现场演出的话题一直是热门，本站的社会热点栏目将持续更新这类超燃现场、活动名场面与全网热议内容，想第一时间看到就去刷新页面吧。",
    ],
  },
  {
    id: "1006",
    title: "新人演员演技获赞，观众在线催更",
    category: "yule",
    tags: ["新剧", "演技", "催更"],
    summary: "新剧开播后新人演员的演技表现获得观众一致认可，弹幕疯狂催更。",
    date: "2026-08-16",
    views: "87万",
    videoCount: 6,
    hot: 6,
    duration: "02:40",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20scene%20of%20young%20asian%20actor%20with%20emotional%20tearful%20expression%20in%20soft%20window%20light%2C%20vintage%20apartment%20interior%2C%20amber%20and%20golden%20tone%2C%20tv%20series%20still%2C%20moody%20intimate%20atmosphere%2C%20editorial&width=800&height=600&seq=gua-1006&orientation=landscape",
    content: [
      "新剧开播后，一名新人演员在剧中的演技表现获得观众一致认可。尤其在几场情感戏里，细腻的表情与自然的肢体语言让许多观众直呼“被圈粉了”，弹幕区满是“演技在线”的评价。",
      "凭借亮眼表现，这位新人演员的相关片段迅速在短视频平台传播，讨论热度一路走高。观众一边盘点高光片段，一边在线催更，希望看到角色后续更完整的情感线。",
      "面对观众的热情，主创团队在采访中透露了更多角色设定与幕后花絮，进一步吊足了大家的胃口。相关访谈与拍摄花絮视频也陆续上线，让话题保持高热度。",
      "新剧与演技讨论一直是娱乐八卦栏目的常客，本站持续更新演员动态、高光片段与花絮合集，收藏本站即可第一时间刷到最新内容。",
    ],
  },
  {
    id: "1007",
    title: "美食博主挑战全网最辣，表情管理瞬间失控",
    category: "wanghong",
    tags: ["美食", "挑战", "表情"],
    summary: "美食博主挑战全网最辣食物，被辣到表情失控的场面笑翻网友。",
    date: "2026-08-15",
    views: "76万",
    videoCount: 5,
    hot: 7,
    duration: "02:18",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20toned%20food%20challenge%20scene%20of%20young%20man%20eating%20spicy%20noodles%20with%20tears%20and%20funny%20expression%2C%20red%20chili%20peppers%20on%20table%2C%20steam%20rising%2C%20bright%20warm%20kitchen%20light%2C%20playful%20editorial%20photography%2C%20orange%20amber%20tone&width=800&height=600&seq=gua-1007&orientation=landscape",
    content: [
      "近日，一名美食博主向“全网最辣”发起挑战，结果刚入口几秒就表情管理瞬间失控，被辣到眼眶通红、连连喝水的场面笑翻了一众网友。视频上线后迅速登上热门榜单。",
      "博主在挑战过程中的各种真实反应成为最大看点，从自信满满到狼狈求饶的反差萌让评论区笑成一片。不少网友纷纷效仿，晒出自己挑战同款食物的“翻车现场”。",
      "随着热度上升，博主顺势推出了系列挑战视频，并分享了一些解辣小技巧，让话题兼具娱乐性与实用性。相关二创和表情包也在短视频平台大量传播。",
      "这条视频及后续系列内容已收录至网络红人栏目，想看完整挑战过程和更多博主翻车名场面，刷新本站即可获取最新视频汇总。",
    ],
  },
  {
    id: "1008",
    title: "综艺名场面盘点，笑点与泪点齐飞",
    category: "zongyi",
    tags: ["综艺", "盘点", "名场面"],
    summary: "网友自发盘点本季综艺名场面，笑点泪点齐飞引发集体回忆杀。",
    date: "2026-08-15",
    views: "143万",
    videoCount: 10,
    hot: 8,
    duration: "04:05",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20cozy%20variety%20show%20studio%20set%20with%20bright%20stage%20lights%20and%20colorful%20seating%20for%20guests%2C%20playful%20decorative%20backdrop%20in%20amber%20and%20cream%2C%20energetic%20atmosphere%2C%20editorial%20behind%20the%20scenes%2C%20golden%20warm%20lighting&width=800&height=600&seq=gua-1008&orientation=landscape",
    content: [
      "随着本季热门综艺逐渐进入尾声，网友自发开启了一场“名场面盘点”。从爆笑瞬间到催泪片段，笑点与泪点齐飞的合集引发了一波集体的回忆杀。",
      "盘点视频中，嘉宾们的经典台词、高能互动与意外状况被一一回顾，不少片段让观众再次捧腹，也有一些温情瞬间让弹幕集体“破防”。相关话题热度迅速攀升。",
      "这些盘点内容不仅覆盖老观众，也吸引了不少新观众入坑。许多人顺着盘点去补看完整节目，进一步带动了综艺本身的播放量与讨论度。",
      "综艺现场栏目将持续汇总这类名场面盘点、幕后花絮与嘉宾互动视频，无论新老观众都能在这里找到想看的内容，记得收藏本站每天刷新。",
    ],
  },
  {
    id: "1009",
    title: "明星公益直播一小时，善款数额破纪录",
    category: "mingxing",
    tags: ["公益", "直播", "正能量"],
    summary: "多位明星合体举办公益直播，开播一小时善款数额便刷新纪录。",
    date: "2026-08-14",
    views: "201万",
    videoCount: 13,
    hot: 9,
    duration: "06:12",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20hopeful%20scene%20of%20group%20of%20people%20on%20a%20charity%20live%20stage%20with%20warm%20golden%20backlight%20and%20heart%20hand%20gestures%2C%20soft%20amber%20and%20cream%20tone%2C%20heartwarming%20positive%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=gua-1009&orientation=landscape",
    content: [
      "近日，多位明星合体举办了一场公益直播，为需要帮助的群体筹集善款。直播开播仅一小时，善款数额便刷新了同类活动纪录，暖心场面引发全网关注。",
      "直播过程中，明星们不仅积极互动，还分享了各自参与公益的初心与故事，让原本紧张的筹款氛围变得温情满满。评论区涌入了大量支持与祝福，气氛十分融洽。",
      "活动结束后，主办方公布了善款的用途与后续计划，进一步增强了公众的信任感。相关直播片段与幕后花絮在各大平台传播，正能量话题持续占据热搜。",
      "这场公益直播的相关内容已收录至明星动态栏目，包含完整直播回放、暖心瞬间合集与善款去向解析等视频。想看更多类似的温暖时刻，刷新本站即可获取最新汇总。",
    ],
  },
];

export function getEventById(id: string): GuaEvent | undefined {
  return events.find((e) => e.id === id);
}

export function getEventsByCategory(key: string): GuaEvent[] {
  if (key === "all") return events;
  return events.filter((e) => e.category === key);
}